import $ from 'jquery';
console.log('test');

$(() => {
    const removedServices = window.sage.removedServices;

    if (removedServices && removedServices.length) {
        const ajax_url = window.sage.ajax_url;
        const userStoreID = window.sage.userStoreID;

        $.ajax({
            type: 'post',
            url: ajax_url,
            data: {
                action: 'get_removed_services_notification_modal',
                removed_services: removedServices,
                user_store_id: userStoreID,
                // nonce: nonce,
            },
            success: function (response) {
                if (response.success) {
                    $('#app').append(response.data.html);
                }
            },
            error: function (response) {
                console.log(response);
            },
        });
    }
});
